import React, { useState, useContext } from "react";
import axios from "axios";
import Bar from "../components/Bar";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import "./SearchPage.css";
import RandomQuote from "../components/RandomQuote";

const SearchPage = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (query) => {
    if (!query.trim()) return;
    setError(null);
    setLoading(true);
    try {
      const response = await axios.get(
        `https://bookmatchup.onrender.com/api/search/search-combined/${query}?limit=50`
      );
      setResults(response.data);
    } catch (err) {
      setError("Search failed. Try again.");
      console.error("[SEARCH ERROR]", err);
    } finally {
      setLoading(false);
    }
  };

  const handleGoToDetails = async (book) => {
    try {
      await axios.post("https://bookmatchup.onrender.com/api/book/add-book", {
        itemId: book.itemId,
        title: book.title,
        author_name: book.author_name?.join(", "),
        cover_url: book.cover_url,
        first_publish_year: book.first_publish_year,
        first_sentence: book.first_sentence || "",
        isbn: book.isbn || [],
        author_key: book.author_key || [],
        subject: book.subject || [],
        subject_facet: book.subject_facet || [],
      });

      navigate(`/book/${encodeURIComponent(book.itemId)}`);
    } catch (err) {
      console.error("❌ Failed to add or navigate to book:", err);
      alert("Error loading book details.");
    }
  };
  
  

  const handleAddToWishlist = async (book) => {
    if (!user) return navigate("/login");
    try {
      const addBookRes = await axios.post(
        "https://bookmatchup.onrender.com/api/book/add-book",
        {
          itemId: book.itemId,
          title: book.title,
          author_name: book.author_name?.join(", "),
          cover_url: book.cover_url,
          first_publish_year: book.first_publish_year,
          first_sentence: book.first_sentence || "",
          isbn: book.isbn || [],
          author_key: book.author_key || [],
          subject: book.subject || [],
          subject_facet: book.subject_facet || [],
        }
      );
      const bookId = addBookRes.data._id;

      await axios.post("https://bookmatchup.onrender.com/api/lists/wishlist", {
        userId: user.id,
        bookId,
        title: book.title,
        author_name: book.author_name.join(", "),
        cover_url: book.cover_url,
      });

      alert("Book added to wishlist!");
    } catch (err) {
      console.error("❌ Failed to add to wishlist:", err);
      alert("This book is already on your Wishlist.");
    }
  };

  const handleAddToCompleted = async (book) => {
    if (!user) return navigate("/login");
    try {
      const addBookRes = await axios.post(
        "https://bookmatchup.onrender.com/api/book/add-book",
        {
          itemId: book.itemId,
          title: book.title,
          author_name: book.author_name?.join(", "),
          cover_url: book.cover_url,
          first_publish_year: book.first_publish_year,
          first_sentence: book.first_sentence || "",
          isbn: book.isbn || [],
          author_key: book.author_key || [],
          subject: book.subject || [],
          subject_facet: book.subject_facet || [],
        }
      );
      const bookId = addBookRes.data._id;

      await axios.post("https://bookmatchup.onrender.com/api/lists/completed", {
        userId: user.id,
        bookId,
        title: book.title,
        author_name: book.author_name.join(", "),
        cover_url: book.cover_url,
      });

      alert("Book marked as completed!");
    } catch (err) {
      console.error("❌ Failed to add to completed:", err);
      alert("This book is already on Completed list.");
    }
  };

  return (
    <div className="search-page-container">
      <h1>Search for Books</h1>

      <div className="search-bar-wrapper">
        <Bar onSearch={handleSearch} />
        <p className="search-helper-text">
          Enter a title or author and click Search.
        </p>
      </div>

      {error && <p className="error-message">{error}</p>}

      {loading ? (
        <div className="custom-loading">
          <img
            src="/images/logo-spinner.png"
            alt="Loading..."
            className="rotating-logo"
          />
          <p className="loading-text">Searching...</p>
        </div>
      ) : results.length === 0 ? (
        <div className="no-results-wrapper">
          <p className="no-results-message">
            No matches found. Try searching again by author, title, or keyword.
          </p>
          <RandomQuote />
        </div>
      ) : (
        <div className="search-results">
          {results.map((book, index) => (
            <div key={index} className="search-card">
              {book.cover_url && (
                <img
                  src={book.cover_url}
                  alt="Book Cover"
                  className="search-cover"
                  onClick={() => handleGoToDetails(book)}
                  style={{ cursor: "pointer" }}
                />
              )}
              <h3
                className="book-title"
                onClick={() => handleGoToDetails(book)}
                style={{ cursor: "pointer", textDecoration: "underline" }}
              >
                {book.title}
              </h3>
              <p className="book-author">{book.author_name?.join(", ")}</p>

              <div className="button-group">
                <button
                  className="button-danger"
                  onClick={() => handleAddToWishlist(book)}
                >
                  Add to Wishlist
                </button>
                <button
                  className="button-style"
                  onClick={() => handleAddToCompleted(book)}
                >
                  Mark as Completed
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchPage;
